<template>
    <div class="text-center my-5">
        <div class="d-inline-block">
            <h1 class="mb-3">
                Inspirational Quotes
                <v-btn
                    x-small
                    icon
                    class="mb-4"
                    color="info"
                    @click="showTip = !showTip"
                >
                    <v-icon>mdi-information-outline</v-icon>
                </v-btn>
            </h1>
            <transition name="fade">
                <v-alert
                    v-if="showTip"
                    border="left"
                    color="info"
                    icon="mdi-information-outline"
                    elevation="1"
                    align="left"
                    close-text="Close this information box"
                    colored-border
                    dense
                >
                    <div>Inspirational Quotes are loaded from local data provided by Greg Jacobs, and not fetched from an external API Endpoint</div>
                    <div class="text-right mt-3">
                        <v-btn
                            x-small
                            color="grey lighten-2"
                            elevation="0"
                            @click="showTip = false"
                        >
                            Close
                        </v-btn>
                    </div>
                </v-alert>
            </transition>
        </div>
        <transition name="fade" mode="out-in">
            <QuoteBubble
                :key="selectedQuoteIndex"
                :selected-quote="selectedQuote.quote"
                :quote-author="selectedQuote.author"
                class="mt-7"
            />
        </transition>
        <div class="mt-15">
            <v-btn @click="randomizeSelectedQuote">
                <span>
                    Quote #{{ selectedQuoteNum }} of {{ quotes.length }}
                </span>
                <v-icon right>mdi-refresh</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { getQuotes } from "@/data/quotes";
    import QuoteBubble from '../components/QuoteBubble';

    export default {
        components: {QuoteBubble},
        data() {
            return {
                showTip: false,
                selectedQuoteIndex: 0,
                quotes: getQuotes(),
            };
        },

        created() {
            this.randomizeSelectedQuote();
        },

        computed: {
            selectedQuote() {
                return this.quotes[this.selectedQuoteIndex];
            },
            selectedQuoteNum() {
                return this.selectedQuoteIndex + 1;
            }
        },

        methods: {
            randomizeSelectedQuote() {
                this.selectedQuoteIndex = Math.floor(Math.random() * this.quotes.length);
            },
        }
    };
</script>
